<template>
  <transition name="custom-classes-transition"
              enter-active-class="animate__animated animate__fadeIn"
              leave-active-class="animate__animated animate__fadeOut">
    <v-alert v-if="alert && alert.show"
             class="nitg__position-fixed nitg__width-100"
             style="z-index: 1000"
             v-model="alert.show"
             tile
             :type="alert.type"
             mode="out-in"
             dismissible>
      <span class="ml-6">{{ alert.message }}</span>
      <v-spacer/>
      <template v-slot:prepend>
        <v-icon v-if="alert.type.includes('success')">mdi-check-circle-outline</v-icon>
        <v-icon v-if="alert.type.includes('warning')">mdi-alert</v-icon>
        <v-icon v-if="alert.type.includes('error')">mdi-alert-circle-outline</v-icon>
      </template>
      <template v-slot:close>
        <v-btn @click="close" icon>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-alert>
  </transition>
</template>

<script>
export default {
  name: 'AlertComponent',
  watch: {
    alert: function () {
      if (this.alert) {
        setTimeout(() => {
          this.$store.dispatch('setAlert', false)
        }, 5000)
      }
    }
  },
  methods: {
    close () {
      this.$store.dispatch('setAlert', false)
    }
  },
  computed: {
    alert () {
      return this.$store.getters.GET_ALERT
    }
  }
}
</script>
